module.exports = __webpack_public_path__ + "static/img/14.8b43789.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/14.png
// module id = pJZX
// module chunks = 0